import { FunctionComponent } from 'react';
import './home-landingpage.scss';
import BuyNowButton from '../../shared/buy-now-button/buy-now-button';
import OurFormula from '../../freetrial/our-formula';
import ImageBanner from '../../home/imagebanner';
import H1 from '../../shared/html-tags/h1';
import { Box } from '@mui/material';
import H2 from '../../shared/html-tags/h2';
import DIV from '../../shared/html-tags/div';

export type Props = {};

const HomeLandingPageTopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div
      className="page-content bg-top-features-1 top-banner bg-landingpage"
      style={{ height: '25.25rem' }}
    >
      <div className="inner-content">
        <div
          className="top-left"
          style={{
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'center',
            marginLeft: '-8rem',
            paddingLeft: '8rem',
            backgroundImage: 'url(/img/features/1/22-bang-300x300.png)',
            backgroundPosition: '0 17rem',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '12.5rem',
            height: '25.5rem',
          }}
        >
          <div>
            <H2 language="de" style={{ color: 'var(--TopGradient1Color1)' }}>
              SPSS Analyse-Lösungen mit IBM SPSS STATISTICS -<br />
              alle Editionen, Kauflizenzen, Mietlizenzen & Module im Überblick
            </H2>
            <H1 language="de" style={{ lineHeight: '1.25' }}>
              Hol mehr aus deinen Daten -
              <br />
              mit SPSS PLUS & PS IMAGO PRO
            </H1>
            <H2 language="de" style={{ fontSize: '1.25rem', marginTop: '0.5rem' }}>
              Erziele schneller, präzisere Ergebnisse,
              <br />
              während du Zeit und Kosten sparst.
            </H2>
            <BuyNowButton order={'buy'} />
          </div>
        </div>
        <DIV language="de" className="top-right">
          <img
            className="top-banner-frame-img"
            src="/img/home/top-banner/74-648x500.png"
            alt="PS IMAGO PRO"
            style={{ border: 'none', marginTop: '0' }}
          />
        </DIV>
      </div>
    </div>
  );
};

export default HomeLandingPageTopBanner;
